import { useContext, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import {
  Box,
  ListWithPagination,
  PaginationContext,
  Spinner,
  ViewerContext,
} from "dash-ui";

import {
  PropertyVisitActivityFragment,
  useGetPropertyVisitActivitiesQuery,
} from "gql/generated.graphql";
import AddPropertyToPortfolioModal from "containers/portfolio/AddPorpertyToPortfolioModal/AddPropertyToPortfolioModal";
import UnavailableActivityPage from "pages/Dashboard/components/BrokersActivityWidget/components/UnavailableActivityPage/UnavailableActivityPage";

import PropertyItem from "./components/PropertyItem/PropertyItem";

const StyledList = styled(ListWithPagination)`
  & > div {
    padding: 0;
    border-bottom: none;
  }
`;

const ViewedProperties = () => {
  const { t } = useTranslation("common");
  const { broker } = useContext(ViewerContext);
  const { state, getRefetchProps, setTotal } = useContext(PaginationContext);
  const pagination = getRefetchProps(state);
  const { data, loading } = useGetPropertyVisitActivitiesQuery({
    variables: {
      pagination,
      sort: [{ fieldName: "createdAt", sortOrder: -1 }],
    },
    fetchPolicy: "network-only",
    skip: !broker,
  });

  const { viewedProperties, total } = useMemo(
    () => ({
      viewedProperties: data?.getPropertyVisitActivities?.collection || [],
      total: data?.getPropertyVisitActivities?.totalCount || 0,
    }),
    [data]
  );

  useEffect(() => {
    setTotal(total);
  }, [total]);

  return (
    <Box pos="relative">
      <AddPropertyToPortfolioModal />
      {viewedProperties.length > 0 ? (
        <StyledList
          mt={4}
          listProps={{ data: viewedProperties, flexDirection: "column" }}
          paginationProps={{
            previousButtonLabel: t("common:labels.previous"),
            nextButtonLabel: t("common:labels.next"),
          }}
        >
          {(item: PropertyVisitActivityFragment) => (
            <PropertyItem visitedProperty={item} />
          )}
        </StyledList>
      ) : (
        <UnavailableActivityPage />
      )}
      {loading && <Spinner fullContent />}
    </Box>
  );
};

export default ViewedProperties;
